import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

interface ITestimonial {
  quoteKey: string;
  nameKey: string;
  roleKey: string;
  avatar: string;
}

@Component({
  selector: 'app-voices',
  templateUrl: './voices.component.html',
  styleUrl: './voices.component.scss',
  standalone: false,
})
export class VoicesComponent {
  carouselOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    items: 1,
    nav: false,
    margin: 20
  };

  readonly testimonials: ITestimonial[] = [
    {
      quoteKey: 'voices.testimonial_1_quote',
      nameKey: 'voices.testimonial_1_name',
      roleKey: 'voices.testimonial_1_role',
      avatar: 'assets/images/png/sushmita.jpg',
    },
    {
      quoteKey: 'voices.testimonial_1_quote',
      nameKey: 'voices.testimonial_1_name',
      roleKey: 'voices.testimonial_1_role',
      avatar: 'assets/images/png/sushmita.jpg',
    },
    {
      quoteKey: 'voices.testimonial_1_quote',
      nameKey: 'voices.testimonial_1_name',
      roleKey: 'voices.testimonial_1_role',
      avatar: 'assets/images/png/sushmita.jpg',
    },
    {
      quoteKey: 'voices.testimonial_1_quote',
      nameKey: 'voices.testimonial_1_name',
      roleKey: 'voices.testimonial_1_role',
      avatar: 'assets/images/png/sushmita.jpg',
    },
    {
      quoteKey: 'voices.testimonial_1_quote',
      nameKey: 'voices.testimonial_1_name',
      roleKey: 'voices.testimonial_1_role',
      avatar: 'assets/images/png/sushmita.jpg',
    },
  ];
}
